<form [ngClass]="valueEditClass" class="form-inline-edit" (ngSubmit)="onSave(newValue)" >
  <input #newValue
         [(ngModel)]="modelValue"
         (click)="onEdit(value)"
         (blur)="onBlur($event,newValue,cancel)"
         (focus)="onEdit(value)"
         (keydown.esc)="onEsc(newValue)"
         [disabled]="!isEditable"
         [type]="type"
         class="form-control form-control-sm"
         name="inline-edit">
  <div class="form-inline-edit-buttons">
    <button #cancel [hidden]="modelValue === value" (click)="onCancel()" class="btn btn-outline-primary btn-sm"
            title="Cancel and revert changes" type="button">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
</form>